var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"badge-container"},[_c('img',{class:{ numbered: _vm.numbered },attrs:{"src":_vm.src}}),_vm._v(" "),(_vm.numbered)?_c('span',{staticClass:"number",class:{
      'for-details': _vm.forDetails,
      white: _vm.whiteNumber,
      'shift-left': _vm.shiftLeft,
    }},[_vm._v(_vm._s(this.number))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }